import { Component, OnInit } from '@angular/core';
import { DatastoreService } from 'src/app/core/datastore/datastore.service';
import { MenuItem } from 'src/app/core/types/others/menu-item';

@Component({
  selector: 'app-sidebar-footer',
  templateUrl: './sidebar-footer.component.html',
  styleUrls: ['./sidebar-footer.component.scss'],
})
export class SidebarFooterComponent implements OnInit {
  public footerItems: Array<MenuItem> = [];

  constructor(private dataStoreService: DatastoreService) {}

  ngOnInit(): void {
    this.footerItems = this.dataStoreService.footerItems;
  }
}
